import { configureAutoTrack, record as kinesisRecord } from '@nexiahome/ui-common/utils/kinesisAnalytics'

import type { Session } from 'types/Session'
import { dealerTrackerAttributes } from 'helpers/analyticsAttributes'

const SOURCE = 'DWA'

class KinesisAnalytics {
  static session: Session
  static brand: string

  static autoTrackOptions(session?: Session | null, brand?: string) {
    return { attributes: dealerTrackerAttributes(session, brand) }
  }

  private static startAutoTracking() {
    const options = KinesisAnalytics.autoTrackOptions(KinesisAnalytics.session, KinesisAnalytics.brand)

    configureAutoTrack(SOURCE, { enable: true, type: 'session', options })
    configureAutoTrack(SOURCE, { enable: true, type: 'pageView', options })
  }

  static init(session: Session, brand: string) {
    KinesisAnalytics.session = session
    KinesisAnalytics.brand = brand

    KinesisAnalytics.startAutoTracking()
  }

  static record(
    eventName: string,
    data: Record<string, unknown> = {}
  ) {
    kinesisRecord(
      eventName,
      SOURCE,
      {
        ...dealerTrackerAttributes(KinesisAnalytics.session, KinesisAnalytics.brand),
        ...data
      }
    )
  }
}

export default KinesisAnalytics
